import { createFileRoute } from '@tanstack/react-router'
import { useRouteDigitalProductId } from '@/shared/hooks/useRouteDigitalProductId'

import { DigitalProductFAQ } from '@/features/faq'

export const Route = createFileRoute('/_event/duvidas-frequentes')({
  component: DigitalProductFAQPage
})

function DigitalProductFAQPage() {
  const digitalProductId = useRouteDigitalProductId()

  return <DigitalProductFAQ digitalProductId={digitalProductId} />
}
